<utclub-modal title="Teklif Gönder" [buttons]="buttons">
  <utclub-formly [form]="form" [fields]="fields" [model]="model"></utclub-formly>
</utclub-modal>